import React, { Fragment, useEffect, useState } from "react";

import T from "../../utils/components/T";
import { Grid } from "semantic-ui-react";
import { SPARQLQueryDispatcher } from "../../../sparql";

const fetchPersonWikiSummary = async title => {
  return fetch(
    `https://en.wikipedia.org/api/rest_v1/page/summary/${title}`
  ).then(response => response.json());
};

const fetchPersonWikiData = async uri => {
  const endpointUrl = "https://query.wikidata.org/sparql";
  const queryDispatcher = new SPARQLQueryDispatcher(endpointUrl);
  const sparqlQuery = `
      SELECT 
        ?article ?person ?image ?dateOfBirth ?dateOfDeath ?professionLabel ?placeOfBirthLabel ?placeOfDeathLabel
      WHERE {
          VALUES (?person) {
            (<${uri}>)
          }
          OPTIONAL{ ?person wdt:P18 ?image .}
          OPTIONAL{ ?person wdt:P106 ?profession .}
          OPTIONAL{ ?person wdt:P569 ?dateOfBirth .}
          OPTIONAL{ ?person wdt:P19 ?placeOfBirth . }
          OPTIONAL{ ?person wdt:P570 ?dateOfDeath .}
          OPTIONAL{ ?person wdt:P20 ?placeOfDeath . }
          OPTIONAL {
              ?article schema:about ?person .
              ?article schema:inLanguage "en" .
              FILTER (SUBSTR(str(?article), 1, 25) = "https://en.wikipedia.org/")
          }   
          SERVICE wikibase:label { bd:serviceParam wikibase:language "[AUTO_LANGUAGE],en". }
    }
    LIMIT 10
  `;
  return await queryDispatcher.query(sparqlQuery);
};

const PersonSummary = ({ person }) => {
  if (Object.keys(person).length === 0) {
    return <div>&nbsp;</div>;
  }

  const dateOfBirth =
    person.dateOfBirth &&
    new Date(person.dateOfBirth.value).toLocaleDateString();
  const dateOfDeath =
    person.dateOfDeath &&
    new Date(person.dateOfDeath.value).toLocaleDateString();
  const placeOfBirth =
    person.placeOfBirthLabel && person.placeOfBirthLabel.value;
  const placeOfDeath =
    person.placeOfDeathLabel && person.placeOfDeathLabel.value;

  return (
    <dl className="o-person__summary">
      {person.professions && (
        <Fragment>
          <dt>Profession</dt>
          <dd className="o-person__prop">{person.professions.join(", ")}</dd>
        </Fragment>
      )}
      {dateOfBirth && (
        <Fragment>
          <dt>Born</dt>
          <dd className="o-person__prop">
            {dateOfBirth}
            {placeOfBirth ? ` in ${placeOfBirth}` : ""}
          </dd>
        </Fragment>
      )}
      {dateOfDeath && (
        <Fragment>
          <dt>Died</dt>
          <dd className="o-person__prop">
            {dateOfDeath}
            {placeOfDeath ? ` in ${placeOfDeath}` : ""}
          </dd>
        </Fragment>
      )}
    </dl>
  );
};

async function loadWikiDataFromObject(obj, setPerson) {
  const response = await fetchPersonWikiData(obj.WIKIDATA_URI[0]);
  const people = response.results.bindings;
  const person = people[0];

  person.professions = people.reduce((acc, item) => {
    if (item.professionLabel) {
      acc.push(item.professionLabel.value);
    }
    return acc;
  }, []);

  if (person.hasOwnProperty("article")) {
    //fetch wikipedia summary if article is found in wikidata
    const segments = person.article.value.split("/");
    const title = segments[segments.length - 1];
    const summary = await fetchPersonWikiSummary(title);
    person.extract = summary.extract;
  }

  return person;
}

const Person = ({ obj }) => {
  const [wikiData, setWikiData] = useState({});

  useEffect(() => {
    if (obj.WIKIDATA_URI && obj.WIKIDATA_URI.length > 0) {
      loadWikiDataFromObject(obj).then(data => setWikiData(data));
    }
  }, [obj]);

  const firstName = obj.FIRST_NAME ? obj.FIRST_NAME[0] : "Unknown";
  return (
    <div className="o-person">
      <Grid>
        <Grid.Column width={5}>
          <h2>
            {obj.FIRST_NAME ? (
              <>
                <T>FIRST_NAME</T> <T>TUSSENVOEGSEL</T> <T br>LAST_NAME</T>
              </>
            ) : (
              <>
                <T>INITIALS</T> <T>TUSSENVOEGSEL</T> <T br>LAST_NAME</T>
              </>
            )}
          </h2>
          <PersonSummary person={wikiData} />
        </Grid.Column>
        <Grid.Column width={6}>
          <h3>Biography:</h3>
          <p>{wikiData.extract || ""}</p>
        </Grid.Column>
        <Grid.Column width={5}>
          <img
            className="o-person__portrait"
            style={{ width: "100%" }}
            alt={`Portrait of ${firstName}`}
            src={
              wikiData.image
                ? wikiData.image.value
                : "https://place-hold.it/450x450"
            }
          />
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default Person;
